import React from "react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";
import { Eye, ShieldCheck, Palette, Contrast, ScanEye, ClipboardList, Radar, FileText, Play, Mail } from "lucide-react";

export const SUPPORT_EMAIL = "assistenza@medcompetente.it";

export const Intro = ({ onStart }) => {
  const { t } = useI18n();
  const FEATURES = [
    // Ordine del wizard: l'astigmatismo segue Snellen, non chiude la lista.
    { icon: Eye, key: "intro_f1" }, { icon: Radar, key: "intro_f7" }, { icon: Contrast, key: "intro_f2" },
    { icon: ScanEye, key: "intro_f3" }, { icon: Palette, key: "intro_f4" }, { icon: Eye, key: "intro_f5" },
    { icon: ClipboardList, key: "intro_f6" },
  ];
  return (
    <div className="step-fade" data-testid="intro-step">
      <div className="relative overflow-hidden rounded-xl border border-slate-200 bg-slate-900">
        <img
          src="https://images.pexels.com/photos/5765829/pexels-photo-5765829.jpeg"
          alt="Screening"
          className="absolute inset-0 w-full h-full object-cover opacity-25"
        />
        <div className="relative p-8 sm:p-12 max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-sky-200">
            <ShieldCheck className="w-4 h-4" /> {t("intro_badge")}
          </span>
          <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold tracking-tighter text-white">VisioScreening</h1>
          <p className="mt-4 text-lg text-slate-200 leading-relaxed">{t("intro_desc")}</p>
          <Button size="lg" onClick={onStart} data-testid="start-screening-button"
            className="mt-8 h-12 px-8 text-base font-semibold bg-white text-slate-900 hover:bg-slate-100 transition-colors">
            <Play className="w-5 h-5" /> {t("intro_start")}
          </Button>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {FEATURES.map((f, i) => (
          <div key={i} className="flex items-center gap-3 rounded-md border border-slate-200 bg-white p-4">
            <f.icon className="w-5 h-5 text-primary flex-shrink-0" strokeWidth={1.8} />
            <span className="text-sm font-medium text-slate-700">{t(f.key)}</span>
          </div>
        ))}
      </div>

      <div className="mt-8 flex items-start gap-3 rounded-md border border-amber-200 bg-amber-50 p-5">
        <FileText className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <p className="text-sm text-amber-900 leading-relaxed">
          <strong>{t("intro_notice_b")}</strong> {t("intro_notice")}
        </p>
      </div>

      <div className="mt-8 flex justify-start" data-testid="intro-support">
        <a href={`mailto:${SUPPORT_EMAIL}`}
          className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-primary transition-colors">
          <Mail className="w-4 h-4 flex-shrink-0" strokeWidth={1.8} />
          <span>{t("intro_support")} <span className="font-medium underline underline-offset-2">{SUPPORT_EMAIL}</span></span>
        </a>
      </div>
    </div>
  );
};
